import { ImageWithAreas, SlotWithConfiguration } from '@lib/print/types'

import Photo from '@components/photo'
import PrintArea from './print-area'

interface PrintConfiguratorSlotPrintPreviewProps {
  activeSlot: SlotWithConfiguration
  imageWithAreas?: ImageWithAreas | null
  className?: string
}

const PrintConfiguratorSlotPrintPreview = ({
  activeSlot,
  imageWithAreas,
  className,
}: PrintConfiguratorSlotPrintPreviewProps) => {
  return (
    <div className={className}>
      {!!imageWithAreas && (
        <div className="relative overflow-hidden">
          {imageWithAreas.areas?.map((area) => (
            <PrintArea
              key={area.type}
              area={area}
              freetext={activeSlot.configuration.freetext}
              freetextColor={activeSlot.configuration.freetextColor}
              logo={activeSlot.configuration.logo}
              image={activeSlot.configuration.image}
            />
          ))}
          <Photo image={imageWithAreas?.image} />
        </div>
      )}
    </div>
  )
}

export default PrintConfiguratorSlotPrintPreview
